import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import { useForm } from "react-hook-form";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";


const Register = () => {
    const [userData, setUserData] = useState();

    const { register,
        handleSubmit,
        formState: { errors },
        watch,
        setValue,
        reset,
    } = useForm({
        mode: "onBlur",
        // defaultValues: {
        //     email: userData?.email || ""
        // },
    })
    const params = useParams()
    const navigate = useNavigate()
    const { id } = params;
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    useEffect(() => {
        const getUserData = async () => {
            const response = await axios.get(`${process.env.REACT_APP_API_PATH}/user/${id}`);
            setUserData(response.data.data)
            setValue("email", response.data.data.email)
        }
        if (id) {
            getUserData()
        }
    }, [id, setValue])
    const onSubmit = async (data) => {
        try {
            const { email, password } = data;
            const { Name } = userData;

            // Register user
            const registerResponse = await axios.post(`${process.env.REACT_APP_API_PATH}/register`, {
                Name,
                email,
                password,
            });

            if (registerResponse.status === 201) {
                toast.success("Your request has been submitted successfully");

                // Log in user
                const loginResponse = await axios.post(`${process.env.REACT_APP_API_PATH}/login`, {
                    email,
                    password,
                });

                if (loginResponse.status === 200) {
                    localStorage.setItem("token", loginResponse.data.token);
                    navigate("/companies", { state: { isLoggedIn: true } });
                    reset();
                }
            }
        } catch (error) {
            const errorMsg = error?.response?.data?.message || "An error occurred. Please try again.";
            // toast.error(errorMsg);
            console.error("Error during registration", error);
        }
    };

    const password = watch("password");
    return (
        <>
            <section className="bg-gradient-to-b from-gray-300 to-gray-400">
                <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
                    <div className="w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700">
                        <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
                            <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
                                Create an account
                            </h1>
                            <form className="space-y-4 md:space-y-6" onSubmit={handleSubmit(onSubmit)}>
                                <div>
                                    <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Email</label>
                                    <input type="email" name="email" id="email" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="name@company.com"
                                        readOnly
                                        {...register("email", {
                                            // required: "Email is required",
                                            validate: {
                                                maxLength: (v) =>
                                                    v.length <= 50 ||
                                                    "The email should have at most 50 characters",
                                                matchPattern: (v) =>
                                                    /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                                                        v
                                                    ) || "email address must be a valid address",
                                            },
                                        })} />
                                    {errors.email && (
                                        <small
                                            style={{
                                                color: "red",
                                                fontSize: "12px",
                                                display: "block",
                                            }}
                                        >
                                            {errors.email.message}
                                        </small>
                                    )}
                                </div>
                                <div className="relative">
                                    <label htmlFor="password" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                        Password
                                    </label>
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        id="password"
                                        placeholder="••••••••"
                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                        {...register("password", {
                                            required: "Password is required",
                                            minLength: {
                                                value: 6,
                                                message: "Password must be at least 6 characters long",
                                            },
                                        })}
                                    />
                                    <div
                                        className="absolute top-10 right-3 cursor-pointer text-gray-500"
                                        onClick={() => setShowPassword(!showPassword)}
                                    >
                                        {showPassword ? <FiEye size={20} /> : <FiEyeOff size={20} />}
                                    </div>
                                    {errors.password && <small className="text-red-500 text-xs">{errors.password.message}</small>}
                                </div>

                                {/* Confirm Password */}
                                <div className="relative">
                                    <label htmlFor="confirm-password" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                        Confirm Password
                                    </label>
                                    <input
                                        type={showConfirmPassword ? "text" : "password"}
                                        id="confirm-password"
                                        placeholder="••••••••"
                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                        {...register("confirmPassword", {
                                            required: "Please confirm your password",
                                            validate: (value) =>
                                                value === password || "Passwords do not match",
                                        })}
                                    />
                                    <div
                                        className="absolute top-10 right-3 cursor-pointer text-gray-500"
                                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                    >
                                        {showConfirmPassword ? <FiEye size={20} /> : <FiEyeOff size={20} />}
                                    </div>
                                    {errors.confirmPassword && (
                                        <small className="text-red-500 text-xs">{errors.confirmPassword.message}</small>
                                    )}
                                </div>
                                <button type="submit" className="w-full text-white bg-primary-600 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800">Create an account</button>
                                <p className="text-sm font-light text-gray-500 dark:text-gray-400">
                                    Already have an account? <Link to={'/login'} className="font-medium text-primary-600 hover:underline dark:text-primary-500">Login</Link>
                                </p>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
export default Register;